import { useEffect } from "react";

/**
 * Applies a tenant branding object (HSL tuples) to CSS variables on :root.
 */
export function useApplyTenantBranding(branding) {
  useEffect(() => {
    if (!branding) return;
    const root = document.documentElement;
    if (branding.primary_color) {
      root.style.setProperty("--tenant-primary", branding.primary_color);
      // Sobrescreve o --primary global do Shadcn para que TODOS os componentes
      // (Button, Badge, Switch, etc) usem automaticamente a cor da empresa,
      // eliminando qualquer roxo padrão que apareceria.
      root.style.setProperty("--primary", branding.primary_color);
      // acessibilidade: ring/focus também no tom da marca
      root.style.setProperty("--ring", branding.primary_color);
    }
    if (branding.primary_foreground) {
      root.style.setProperty("--tenant-primary-foreground", branding.primary_foreground);
      root.style.setProperty("--primary-foreground", branding.primary_foreground);
    }
    if (branding.accent_color) root.style.setProperty("--tenant-accent", branding.accent_color);
    if (branding.radius) root.style.setProperty("--tenant-radius", branding.radius);
    if (branding.favicon_url) {
      let link = document.querySelector("link[rel*='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = branding.favicon_url;
    }
    if (branding.display_name) document.title = branding.display_name;
    return () => {
      // Cleanup: restaura --primary padrão quando o admin sair do tenant
      // (útil ao voltar para a matriz — evita a cor do último tenant "vazar").
      root.style.removeProperty("--primary");
      root.style.removeProperty("--primary-foreground");
      root.style.removeProperty("--ring");
    };
  }, [
    branding?.primary_color,
    branding?.primary_foreground,
    branding?.accent_color,
    branding?.radius,
    branding?.favicon_url,
    branding?.display_name,
  ]);
}

// ---------- Terminology (per-vertical labels) ----------

const DEFAULT_TERMS = {
  client_singular: "Cliente",
  client_plural: "Clientes",
  service_singular: "Serviço",
  service_plural: "Serviços",
  appointment_singular: "Atendimento",
  appointment_plural: "Atendimentos",
  resource_singular: "Profissional",
  resource_plural: "Profissionais",
};

/**
 * Resolve niche-specific term with fallback to default Portuguese.
 * Reads from auth.tenant.settings.terminology (set on tenant creation from the template).
 */
export function useTerm(tenant) {
  const map = (tenant?.settings?.terminology) || tenant?.terminology || {};
  return (key, opts = {}) => {
    const val = map[key] || DEFAULT_TERMS[key] || key;
    return opts.lower ? val.toLowerCase() : val;
  };
}
